<template lang="pug">
pr-wrapper.d-flex.flex-column.align-items-stretch.animated.vod-container(fs, bg="overlayFrom", bgo=".7", :class="statusClass")
  pr-wrapper.content.flex-grow-1.row.no-gutters.align-items-end
    .col.col-5.pl-5.pb-5
      vodDetail

  pr-wrapper.list.flex-grow-0.pt-5.animated(bg="overlayFrom", bgd="90")
    .vod-categories.overflow-hidden.pt-5.px-5(v-nv:scope="'vod-categories'", data-up="vod-detail", data-down="vods")
      .animated.scroll-container
        pr-input.background.search-input.flex-grow-1.mr-2(
          :label="$t('Search')",
          text,
          :value.sync="search",
          icon="search",
          fluid,
          small,
          v-nv.current
        )
        pr-button.vod-category.background.scale-xs.nv-el(small, v-nv, :class="{ active: !category }", @nv-enter="choose(null)") {{ $t('All') }}
        pr-button.vod-category.background.scale-xs.nv-el(
          small,
          v-nv,
          v-for="(_category, index) in categories",
          :key="index",
          :class="{ active: category === _category }",
          @nv-enter="choose(_category)"
        ) {{ $t(_category) }}
    .vod-list.overflow-hidden.pt-3(
      v-nv:scope="'vods'",
      data-scroll="center",
      data-up="vod-categories",
      @nv-scope-focus="focused",
      @nv-enter="detail",
      @nv-back="goHome"
    )
      pr-wrapper.animated.scroll-container.px-5.pt-2.pb-3(bg="overlayFrom", bgd="90")
        .vod-item.animated.all(
          v-nv,
          v-for="(vod, index) in vods",
          :key="vod.id",
          @nv-focus="select(index)",
          :class="{ [vod.slug]: true }",
          :data-title="vod.title"
        )
          imagec.scale-sm.background.animated.shadow.border(:src="vod.cover", :alt="vod.title", vertical) 
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import vodDetail from "./detail"

export default {
  name: "vod",
  components: { vodDetail },
  data() {
    return {
      search: null,
      timeout: null,
      background: "overlayFrom"
    }
  },
  computed: {
    statusClass() {
      return {
        [this.status]: true
      }
    },
    ...mapGetters("vod", ["vods", "vod", "status", "categories", "category"])
  },
  watch: {
    search(nval) {
      if (nval === "") {
        this.search = null
        this.$nextTick(() => _$.nav.refreshScope("vods"))
        return
      }
      if (!nval && _$.nav.currentScopeName().startsWith("vod")) return
      if (this.category) this.choose(null)

      const container = document.getElementById("vods")
      if (!container) return
      const vods = Array.from(container.querySelectorAll(".all"))
      for (let element of vods) {
        element.style.display = !nval
          ? null
          : element.dataset.title
              .replace(/(\r\n|\n|\r|\s)/gm, "")
              .toLowerCase()
              .includes(nval.replace(/(\r\n|\n|\r|\s)/gm, "").toLowerCase())
          ? null
          : "none"
      }
      this.$nextTick(() => _$.nav.refreshScope("vods", this._inactive))
    },
    async category(nval) {
      await this.$nextTick()
      if (_$.nav.currentScopeName().startsWith("keyboard")) return
      else this.search = null

      const container = document.getElementById("vods")
      if (!container) return
      const vods = Array.from(container.querySelectorAll(".all"))
      for (let element of vods) {
        element.style.display = !nval ? null : element.classList.contains(nval.slugify()) ? null : "none"
      }
      _$.nav.refreshScope("vods", this._inactive)
      if (!this._inactive) _$.nav.changeScope("vods")
    },
    vods() {
      if (this.category) this.setCategory(null)
      else this.$nextTick(() => _$.nav.refreshScope("vods", this._inactive))
    },
    status(nval, oval) {
      if (this._inactive) return false
      if (!nval && oval) this.changeBackground()
    }
  },
  activated() {
    _$.nav.changeScope("vods")
    this.changeBackground()
  },
  beforeRouteLeave(to, from, next) {
    if (this.timeout) _$.removeTimeout(this.timeout)
    next()
  },
  mounted() {
    _$.nav.sync("vods")
    _$.nav.sync("vod-categories")
  },
  methods: {
    focused() {
      if (!_$.nav._scopes["vods"].navigationElements.length) _$.nav.changeScope("vod-categories")
      else this.setStatus(false)
    },
    detail() {
      _$.nav.changeScope("vod-detail")
    },
    select(index) {
      if (this.timeout) _$.removeTimeout(this.timeout)

      this.timeout = _$.makeTimeout(async () => {
        this.setVod(index)

        await this.$nextTick()
        this.changeBackground()
      }, 500)
    },
    choose(category) {
      this.setCategory(category)
    },
    changeBackground() {
      __.platform.background(this.vod.poster)
    },
    ...mapMutations("vod", ["setVod", "setStatus", "setCategory"])
  }
}
</script>

<style lang="scss" scoped>
.vod-container {
  transform: translateY(0) !important;
  .vod-categories {
    .scroll-container {
      position: relative;
      display: inline-flex;
      align-items: flex-end;
      overflow: initial;
      min-width: 100%;

      .search-input {
        padding: 0.35em 1.25em !important;
      }

      .vod-category {
        margin-left: -1px;
        white-space: nowrap;
      }
    }
  }

  &.trailer {
    .vod-categories {
      opacity: 0.5;
    }
    .list {
      transform: translateY(50%) !important;
    }
  }
}

.content {
  margin-bottom: -3rem;
}
.vod-list {
  .scroll-container {
    position: relative;
    display: inline-flex;
    align-items: flex-end;
    overflow: initial;
    min-width: 100%;

    .vod-item {
      min-height: 178px;
      max-height: 178px;
      transform-origin: center bottom;
      padding: 0 10px;

      .imagec {
        display: block;
        border-radius: 5px;
        border-width: 2px !important;
        height: 176px;
      }
    }
  }
}
</style>
